import React from "react";
import styled from "styled-components";
import { useSelector } from "react-redux";
import ScrollTable from './ScrollTable';

const ActivityContent = styled.div`
	background: #e5f2ff;
	width: 100%;
	min-height: 299px;
	padding: 20px 40px;

	@media (max-width: 991px) {
		padding: 20px 15px;
	}

	.slider-title {
		font-weight: bold;
		font-size: 15px;
		display: block;
		width: 100%;
		text-align: center;
	}
	
`;

function Activity(props) {
	const activities = useSelector(state => state.activities);

	activities.sort(function (a, b) {
		return new Date(b.last_updated) - new Date(a.last_updated);
	});

	let activityItems = [...activities].splice(0, 10);

	return (
		<ActivityContent>
			<div className="row mb-4">
				<div className="col-12"><span className="slider-title">Activity Updates</span></div>
			</div>
			<ScrollTable activities={activityItems} />
		</ActivityContent>
	);
}

export default Activity;
